/**
 * @author: lv.chen
 * @date: 2025/12/29
 * @desc: 近三日GRC报告组件
 */
import React from 'react';
import { history } from 'umi';
import GrcReportCard from './GrcReportCard';
import { isEmpty } from '@intelligence/v3/utils/common';
import { getCurrentRoutePath } from '@intelligence/utils/commonUtils';

import IMG_TITLE_GRC from '@intelligence/assets/imgs/casualDailyReports/title-grc.png';

interface IGrcReportProps extends IBaseProps {
  /** GRC报告数据列表 */
  reports?: IGRCReportItem[] | null;
}

const GrcReportRecentThreeDays: React.FC<IGrcReportProps> = (props) => {
  const { reports } = props;

  // 无数据时不显示
  if (isEmpty(reports)) {
    return null;
  }

  const handleGoToReportDetails = (report: IGRCReportItem | null) => {
    const { resource_id: resourceId } = report || {};

    if (!resourceId) {
      return;
    }

    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('systemId', 'gameResearch');
    urlSearchParams.set('resourceId', resourceId);
    urlSearchParams.set('lang', 'en');
    urlSearchParams.set('referer', getCurrentRoutePath());

    history.push(
      `/intelligence/pdfPreviewDownloadLikeShare?${urlSearchParams.toString()}`,
    );
  };

  return (
    <div className="dbi-section-grc">
      <div className="dbi-section-grc-title">
        <img className="dbi-section-production-title-img" src={IMG_TITLE_GRC} alt="" />
      </div>
      <div className="dbi-section-grc-content">
        <div className="dbi-section-grc-box">
          <div className="dbi-section-grc-box-wrap">
            <div className="dbi-grc-item-list">
              {reports?.map((report) => (
                <GrcReportCard
                  key={report?.resource_id}
                  report={report}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onGoToReportDetails={handleGoToReportDetails}
                />
              ))}
            </div>
          </div>
        </div>

        <div
          className="dbi-button-report-more"
          onClick={(e) => {
            e.stopPropagation();
            history.push('/intelligence/gameResearchReport');
          }}
        >
          <span>查看更多报告</span>
        </div>
      </div>
    </div>
  );
};

export default GrcReportRecentThreeDays;
